//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { IInstagramUsedHashtag } from '@apis/instagram-hashtags-usage/instagramHashtagsUsageApiModels';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';
import { groupBy } from '@utils/groupBy';

export const isWithinLastWeek = (date: Date) => {
  return DateString.isWithin(DateString.fromTimestamp(date, TimeZoneId.Utc), {
    minDate: DateString.addDays(DateString.getToday(TimeZoneId.Utc), -7),
    maxDate: DateString.getToday(TimeZoneId.Utc),
  });
};

export const groupHashtagsByRecentActivity = (
  hashtags: IInstagramUsedHashtag[],
) => {
  return groupBy(hashtags, (hashtag) => {
    return hashtag.endDate ? isWithinLastWeek(hashtag.endDate) : false;
  });
};
